<pt-breadcrumbs
  [breadcrumbs]="breadcrumbs"
  current="Practitioner Reports"
  class="bg-white"
/>
<div class="border-b border-solid border-slate-300"></div>

<div class="layout-padding">
  <div class="layout-margin flex items-center justify-between">
    <h2 class="!mb-0">Practitioner Income Report</h2>
    @if (brand$ | async; as brand) {
      <a
        *ngIf="canConfigureSettings$ | async"
        mat-icon-button
        matTooltip="Practitioner Income Settings"
        [routerLink]="['/settings', 'brand', brand.ref.id, 'accounting']"
      >
        <mat-icon>settings</mat-icon>
      </a>
    }
  </div>
  <div fxLayout="row wrap" fxLayoutGap="16px" class="layout-margin">
    <pt-date-range-form
      [useRangePicker]="true"
      [from]="from"
      [to]="to"
      (changed)="updateDateRange($event)"
    />
    <pr-practice-selector
      [brands]="brands$ | async"
      [practice]="practice$ | async"
      (practiceSelected)="practice$.next($event)"
    />
    <pr-practitioner-income-report-type-selector />
    <button
      mat-flat-button
      class="submit-button"
      color="primary"
      (click)="runReport$.next()"
    >
      Run
    </button>
  </div>

  <div class="layout-margin" fxLayout="column">
    <pr-practitioner-transactions-report
      *ngIf="isTransactionReport$ | async; else invoiceReport"
      [request]="request$ | async"
    />

    <ng-template #invoiceReport>
      <pr-practitioner-income-table [request]="request$ | async" />
    </ng-template>
  </div>
</div>
